"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDisplayCategoryDto = void 0;
class UpdateDisplayCategoryDto {
    /* @deprecated usar el titulo como key de traduccion */
    translations;
    priority;
    pricingMultiplier;
    baseCpm;
    stripe;
    name;
    /**
     * @deprecated usar el nombre como key de traduccion
     */
    title;
    allow_adult_content;
    is_archived;
    /**
     * @deprecated
     */
    picture_url;
    /**
     * @deprecated
     */
    picture_name_url;
    /**
     * @deprecated
     */
    video_url;
    hide;
    business;
    price;
    interval;
}
exports.UpdateDisplayCategoryDto = UpdateDisplayCategoryDto;
